// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Previous$Showside from "./Previous.bs.js";
function use(value) {
  var previous = Previous$Showside.usePreviousDistinct(value);
  if (value !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(value));
  } else {
    return previous;
  }
}
export { use };
/* Previous-Showside Not a pure module */